const React = require('react');
const upperFirst = require("mn-utils/upperFirst");
const Tooltip = require('../../../../../dumb/Tooltip/B');
const formatNumFiat = require('../../../../../../utils/formatNumFiat');
const {AdminTimeCell} = require('../../../../../dumb/TableTimeCell/');
const RefTableRow = require('../../../../../dumb/TableRow/RefTableRow');

module.exports = ({data, index}) => {
  return (
    <RefTableRow
      className="(wmin130|w1/4)>1"
      index={index}
    >
      <div>
        {upperFirst(data.transaction_kind || '').replace('_', ' ')}
      </div>
      <div>
        <Tooltip title={data.amount} className="fhaS">
          {formatNumFiat(data.amount)} {data.code}
        </Tooltip>
      </div>
      <div>
        <AdminTimeCell date={data.date_time} />
      </div>
      <div>
        {data.status ? upperFirst(data.status) : ''}
      </div>
    </RefTableRow>
  )
}